import { IconWifi } from '@tabler/icons-react';
import { useSelector } from 'react-redux';

import { RootState } from '@/store';
import { selectDevicesWithUpcomingAppointment } from '@/store/selectors/transmissionReportPatientSelectors';
import { formatUtcDate } from '@/utils/formatDate';

import styles from './NextTransmissionSection.module.scss';

interface NextTransmissionSectionProps {
  patientId: string;
}

const NextTransmissionSection = ({ patientId }: NextTransmissionSectionProps) => {
  const devicesWithAppointments = useSelector((state: RootState) =>
    selectDevicesWithUpcomingAppointment(state, patientId)
  );

  if (!devicesWithAppointments.length) {
    return null;
  }

  return (
    <div className={styles.transmissionContainer}>
      {devicesWithAppointments.map(({ device, nextAppointment }) => {
        const dateToShow = nextAppointment?.scheduledDate
          ? formatUtcDate(nextAppointment.scheduledDate)
          : '-';

        if (!dateToShow) {
          return null;
        }

        return (
          <div key={device.id} className={styles.transmissionBlock}>
            <div className={styles.leftSection}>
              <IconWifi className={styles.deviceIcon} /> {device.type}
            </div>

            <div className={styles.rightSection}>
              <div className={styles.nextText}>NEXT TRANSMISSION</div>
              <div className={styles.date}>{dateToShow}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NextTransmissionSection;
